import * as React from 'react'
import './index.scss'
import { WebAnchorItem, WebAnchorItemDesc, None, Loading, WithPage } from '@huyafed/comp'
interface Props {
  data: any,
  loading: boolean,
}
const WholeRank: React.FC<Props> = (props) => (
  <div
    className='web-wholeRank'
  >
    {
      props.loading ?
        <Loading from={2} />
        :
        <>
          <WebAnchorItemDesc
            width={860}
            color='#53abfd'
            descs={['排名', '主播昵称', `车技值`]}
          />
          <div className='whole-List'>
            {
              props.data.length === 0 ?
                <None text={'暂无飙车总榜数据'} />
                :
                props.data.map((item: any) => (
                  <WebAnchorItem
                    key={item.tJump.lPid}
                    width={860}
                    isLarge={true}
                    color={'white'}
                    borderColor={'#53abfd'}
                    canJump={true}
                    msg={{...item, tJump: {...item.tJump, bIsLive: item.tJump.iIsLive}}}
                  />
                ))
            }
          </div>
          {props.children}
        </>
    }
  </div>
)

export default WithPage(WholeRank);